const BASKET_COOKIE = /(?:^|; ?)cached_basket=([^;]+)/;

const mapServiceItems = (services) => {
  const [, productId, sku, itemPrice, qty] = services.split("-");
  return {
    itemPrice,
    productId,
    qty,
    sku,
  };
};

const mapBasketItems = (item) => {
  const [, productId, , sku, itemPrice, qty, additionalServices] =
    item.split("|");

  const services = [];

  if (additionalServices) {
    // TODO: what if there are more than 1 "addons"?
    // I could only find an instance where there is 1 additional addon
    services.push(...[additionalServices].map(mapServiceItems));
  }

  return {
    itemPrice,
    productId,
    services,
    qty,
    sku,
  };
};

export const setJLBasketData = () => {
  const [, basketCookie] =
    typeof document !== "undefined"
      ? // eslint-disable-next-line no-undef
        document.cookie.match(BASKET_COOKIE) || []
      : [];

  if (!basketCookie) {
    return {};
  }

  // split all items in the cookie string
  const basket = basketCookie.split(/\|?\^/);

  // retrieve the totals (appear to ALAWYS be last two elements)
  const totals = basket.splice(basket.length - 2);

  // reduce the totals array and build an object of keys and values
  const information = totals.reduce((obj, info) => {
    const [key, value] = info.split("=");
    return Object.assign(obj, { [key]: value });
  }, {});

  const products = basket.map(mapBasketItems);

  return {
    product: products,
    ...information,
  };
};
